export interface BuildQueryParamsConfig {
  ignoreEmpty: boolean;
}
export function buildQueryParams(
  params: Record<string, unknown>,
  config: BuildQueryParamsConfig = { ignoreEmpty: true },
): Record<string, string | number | boolean | readonly (string | number | boolean)[]> {
  const queryParams: Record<
    string,
    string | number | boolean | readonly (string | number | boolean)[]
  > = {};

  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null) {
      if (config.ignoreEmpty && params[key] === '') {
        continue;
      }
      queryParams[key] = params[key] as
        | string
        | number
        | boolean
        | readonly (string | number | boolean)[];
    }
  }

  return queryParams;
}
